var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { takeLatest, call, select, put, } from 'redux-saga/effects';
import { getJrniGrandParentId } from '../utils';
import { actions } from './actions';
import { getQuestionsGroup } from './requests';
import { ActionTypes } from './actions';
export function fetchQuestionsGroup(_a) {
    var jrniGrandparentId, response, error_1;
    var _b = _a.payload, groupId = _b.groupId, onSuccess = _b.onSuccess, onError = _b.onError;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 6, , 10]);
                return [4 /*yield*/, select(getJrniGrandParentId)];
            case 1:
                jrniGrandparentId = _c.sent();
                return [4 /*yield*/, call(getQuestionsGroup, groupId, jrniGrandparentId)];
            case 2:
                response = _c.sent();
                return [4 /*yield*/, put(actions.fetchQuestionsGroupSuccess(response))];
            case 3:
                _c.sent();
                if (!onSuccess) return [3 /*break*/, 5];
                return [4 /*yield*/, call(onSuccess)];
            case 4:
                _c.sent();
                _c.label = 5;
            case 5: return [3 /*break*/, 10];
            case 6:
                error_1 = _c.sent();
                if (!onError) return [3 /*break*/, 8];
                return [4 /*yield*/, call(onError)];
            case 7:
                _c.sent();
                _c.label = 8;
            case 8: return [4 /*yield*/, put(actions.fetchQuestionsGroupFailure(error_1))];
            case 9:
                _c.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
export function sagas() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(ActionTypes.FETCH_QUESTIONS_GROUP, fetchQuestionsGroup)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
